import {
    UserPortfolioState,
    PortfolioData,
    PortfolioFullSection,
} from './user_portfolio.types';
import { DEFAULT_PAGE_SIZE } from './user_portfolio.constants';

export const emptyPortfolioData: PortfolioData = {
    data_user: null,
    totalProperties: 0,
    totalStatus: 0,
    properties: [],
    slots: [],
    totalSlots: 0,
    userType: '',
};

export const emptyPortfolioFull: PortfolioFullSection = {
    slots: [],
    properties: [],
    totalSlots: 0,
    totalProperties: 0,
    loading: false,
    error: null,
    loadedForParameter: null,
};

export const initialUserPortfolio: UserPortfolioState = {
    portfolio: {
        ...emptyPortfolioData,
        page: 0,
        propertyPage: 0,
        pageSize: DEFAULT_PAGE_SIZE,
        loading: false,
        error: null,
        loadedForParameter: null,
        slotFilter: '',
        propertyFilter: '',
        slotsOrder: null,
        saving: false,
        saveError: null,
        assigning: false,
        assignError: null,
        creating: false,
        createError: null,
    },
    full: { ...emptyPortfolioFull },
};
